import { alpha } from '@mui/material';
import {
  GridRenderEditCellParams,
  useGridApiContext,
} from '@mui/x-data-grid-premium';
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium';
import { MutableRefObject, useCallback, useMemo } from 'react';

import { AttachmentInput } from '~/components/AttachmentInput';

type PropsType = {
  params: GridRenderEditCellParams;
  onCellFileChange: (cellProps: {
    value: File | undefined;
    params: GridRenderEditCellParams;
    apiRef: MutableRefObject<GridApiPremium>;
  }) => void;
  getAttachmentUrl?: (cellProps: {
    params: GridRenderEditCellParams;
  }) => string | undefined;
  required?: boolean;
};

export const AttachmentEditCellComponent = (props: PropsType) => {
  const { params, onCellFileChange, required, getAttachmentUrl } = props;
  const { value, isEditable, error } = params;

  const apiRef = useGridApiContext();

  const isDisabled = !isEditable;

  const handleChange = useCallback(
    (value: File | undefined) => {
      return onCellFileChange({
        apiRef,
        params,
        value,
      });
    },
    [params, apiRef, onCellFileChange],
  );

  const attachmentUrl = useMemo(() => {
    return !!getAttachmentUrl ? getAttachmentUrl({ params }) : undefined;
  }, [getAttachmentUrl, params]);

  return (
    <AttachmentInput
      onChange={handleChange}
      value={value}
      fullWidth={true}
      disabled={isDisabled}
      error={!!error}
      size={'small'}
      required={required}
      attachmentUrl={attachmentUrl}
      slotProps={{
        selectedFile: {
          sx: {
            '&.hasAttachmentUrl, &': {
              '& .MuiInputBase-root': {
                fontSize: 'inherit',
                borderRadius: 0,
                borderColor: 'transparent',
                '& fieldset.MuiOutlinedInput-notchedOutline': {
                  borderColor: 'transparent',
                },
              },
              '& .MuiButtonBase-root': {
                borderRadius: 0,
                borderColor: 'transparent',
              },
            },
          },
        },
        downloadDivider: {
          sx: {
            borderRadius: 0,
            borderColor: 'transparent',
            borderWidth: 0,
            backgroundColor: alpha('#fff', 0.8),
            padding: 0,
          },
        },
      }}
    />
  );
};
